import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import {BLUE, GRAY_DARKER} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export enum ColumnSortState {
  UNSORTED = 'unsorted',
  DESCENDING = 'descending',
  ASCENDING = 'ascending',
}

export interface SortableRunQueryOutputTableHeaderCellProps {
  header: string;
  columnSortState: ColumnSortState;
  onSortClick: () => void;
}

export default function SortableRunQueryOutputTableHeaderCell(
  props: SortableRunQueryOutputTableHeaderCellProps
): JSX.Element {
  const [isHovered, setIsHovered] = useState(false);

  // The icon is:
  // - transparent (for consistent spacing) when the column is not being sorted
  //   and the mouse is not hovered on it.
  // - dark gray when being hovered and the column isn't sorted.
  // - blue when it is being sorted regardless of hover state.
  const iconStyle =
    props.columnSortState !== ColumnSortState.UNSORTED
      ? runQueryOutputTableHeaderStyles.sortedIcon
      : isHovered
        ? runQueryOutputTableHeaderStyles.hoveredUnsortedIcon
        : runQueryOutputTableHeaderStyles.unhoveredUnsortedIcon;

  return (
    <div
      className={css(runQueryOutputTableHeaderStyles.wrapper)}
      onMouseOver={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
    >
      <div className={css(runQueryOutputTableHeaderStyles.text)}>{props.header}</div>
      <BenchlingIcon
        className={css(runQueryOutputTableHeaderStyles.sortIcon, iconStyle)}
        onClick={() => {
          props.onSortClick();
        }}
        icon={
          props.columnSortState === ColumnSortState.DESCENDING ||
          props.columnSortState === ColumnSortState.UNSORTED
            ? 'arrow-down'
            : 'arrow-up'
        }
      />
    </div>
  );
}

export const runQueryOutputTableHeaderStyles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  text: {
    marginRight: 6,
  },
  sortIcon: {
    cursor: 'pointer',
  },
  sortedIcon: {
    color: BLUE,
  },
  unhoveredUnsortedIcon: {
    color: 'transparent',
  },
  hoveredUnsortedIcon: {
    color: GRAY_DARKER,
  },
});
